export default __webpack_public_path__ + "static/logo-porfesr-705cabd87b56b53eeb9513c849e423bd.jpg";